module.exports = __webpack_public_path__ + "static/media/33.d5a0fb03.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/mouth/33.png
// module id = 816
// module chunks = 0